/**
 * Authentication API Service
 */
import { apiClient } from '../client';
import { API_ENDPOINTS } from '../../utils/constants';
import type { LoginRequest, RegisterRequest, GoogleAuthRequest, AuthResponse, User } from '../../types';

export const authService = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, data);
    return response.data;
  },

  googleLogin: async (data: GoogleAuthRequest): Promise<AuthResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.GOOGLE, data);
    return response.data;
  },

  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get(API_ENDPOINTS.AUTH.ME);
    return response.data;
  },

  updateCurrentUser: async (data: Partial<Pick<User, 'show_sample_dashboard'>>): Promise<User> => {
    const response = await apiClient.patch(API_ENDPOINTS.AUTH.ME, data);
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<{ access_token: string }> => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH, {
      refresh_token: refreshToken,
    });
    return response.data;
  },
};

